// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"123":"icons","293":"itamat","333":"party","353":"contact","389":"404","539":"misc"}[chunkId] || chunkId) + "." + {"123":"ffb8478a","293":"7d1fb76f","333":"f9702689","353":"34c5d573","358":"6658699c","389":"b6c8f6bc","539":"d081af3c"}[chunkId] + ".js";
};